module.exports = __webpack_public_path__ + "img/GordonFreemanPhD.30cf2509.png";